<template>
  <div class="notification-settings-page container py-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2>
        <font-awesome-icon icon="bell" class="me-2" />
        Benachrichtigungseinstellungen
      </h2>
      <div>
        <BackButton class="me-2" fallback="profile" />
      </div>
    </div>
    <div class="mb-4">
      <p class="page-description">
        Konfiguriere deine bevorzugten Benachrichtigungskanäle für verschiedene Ereignisse
      </p>
    </div>

    <NotificationSettings />
  </div>
</template>

<script>
import NotificationSettings from '@/components/NotificationSettings.vue'

export default {
  name: 'NotificationSettingsView',
  components: {
    NotificationSettings
  }
}
</script>

<style scoped>

.page-description {
  color: #64748b;
  font-size: 1rem;
  margin: 0;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .breadcrumb {
    flex-wrap: wrap;
    gap: 0.25rem;
  }
  
  .breadcrumb-item {
    font-size: 0.8rem;
  }
}
</style>
